import get from 'just-safe-get';

/**
 * @deprecated Since version 0.11.0. We recommend Yup as an alternative (https://www.npmjs.com/package/yup).
 */
export const required = (value: any, label: string): string | undefined => {
  if (!value && value !== 0) {
    return `${label} is required.`;
  }

  return undefined;
};

/**
 * @deprecated Since version 0.11.0. We recommend Yup as an alternative (https://www.npmjs.com/package/yup).
 */
export const number = (value: any, label: string): string | undefined => {
  if (isNaN(parseFloat(value))) {
    return `${label} must be a number.`;
  }

  return undefined;
};

/**
 * @deprecated Since version 0.11.0. We recommend Yup as an alternative (https://www.npmjs.com/package/yup).
 */
export const min = (minValue: number) => (
  value: number,
  label: string
): string | undefined => {
  if (value < minValue) {
    return `${label} cannot be less than ${minValue}.`;
  }

  return undefined;
};

/**
 * @deprecated Since version 0.11.0. We recommend Yup as an alternative (https://www.npmjs.com/package/yup).
 */
export const minGreaterThan = (minValue: number) => (
  value: number,
  label: string
): string | undefined => {
  if (value <= minValue) {
    return `${label} must be greater than ${minValue}.`;
  }

  return undefined;
};

/**
 * @deprecated Since version 0.11.0. We recommend Yup as an alternative (https://www.npmjs.com/package/yup).
 */
export const max = (maxValue: number) => (
  value: number,
  label: string
): string | undefined => {
  if (value > maxValue) {
    return `${label} cannot be greater than ${maxValue}.`;
  }

  return undefined;
};

/**
 * @deprecated Since version 0.11.0. We recommend Yup as an alternative (https://www.npmjs.com/package/yup).
 */
export const maxLessThan = (maxValue: number) => (
  value: number,
  label: string
): string | undefined => {
  if (value >= maxValue) {
    return `${label} must be less than ${maxValue}.`;
  }

  return undefined;
};

/**
 * @deprecated Since version 0.11.0. We recommend Yup as an alternative (https://www.npmjs.com/package/yup).
 */
export const phoneNumber = (
  value: string,
  label: string
): string | undefined => {
  if (!/^\d{10}$/g.test(value)) {
    return `${label} must be in 10-digit format with no non-digit characters (ie. 8887771642).`;
  }

  return undefined;
};

/**
 * @deprecated Since version 0.11.0. We recommend Yup as an alternative (https://www.npmjs.com/package/yup).
 */
export const createValidator = (formMap: any) => {
  const isNested = (value: any) =>
    !get(value, 'label') && !get(value, 'validators');

  const createValidationFunction = ({
    label,
    validators,
  }: {
    label: string;
    validators: any[];
  }) => {
    if (label && validators) {
      const validationStack = Array.isArray(validators)
        ? validators
        : [validators];
      return (value: any) => {
        for (const validator of validationStack) {
          const message = validator(value, label);
          if (message) {
            return message;
          }
        }
        return undefined;
      };
    } else {
      throw new Error(
        'All validation statements require a "label" and "validators" property.'
      );
    }
  };

  const validationFunctionsByProperty = Object.keys(formMap).reduce(
    (acc: any, key: any) => {
      const value = get(formMap, key);
      if (isNested(value)) {
        acc[key] = createValidator(value);
      } else {
        acc[key] = createValidationFunction(value);
      }
      return acc;
    },
    {}
  );

  return (values: any) => {
    let errorExists = false;
    const computedErrors = Object.keys(validationFunctionsByProperty).reduce(
      (acc: any, key: any) => {
        const validationFunction = validationFunctionsByProperty[key];
        if (typeof validationFunction === 'function') {
          acc[key] = validationFunction(get(values, key));
          // NOTE - Not in love with this pattern, but it's more efficient than checking the whole object later.
          if (typeof acc[key] === 'string' && !errorExists) {
            errorExists = true;
          }
        }
        return acc;
      },
      {}
    );
    return errorExists ? computedErrors : {};
  };
};
